import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const RestrictLoginPage = lazy(() => import('../restrict/pages/RestrictLoginPage'));
const RestrictDashboardPage = lazy(() => import('../restrict/pages/RestrictDashboardPage'));

export function RestrictRoutes() {
  return (
    <Routes>
      <Route path="login" element={<RestrictLoginPage />} />
      <Route path=":id/dashboard" element={<RestrictDashboardPage />} />
    </Routes>
  );
}

